<template>
  <v-app>
    <dashboard-Core-App-Bar />
    <dashboard-core-drawer />
    <dashboard-core-view />
    <dashboard-core-settings />
    <set-responsible-person-dialog v-model="showResponsiblePersonDialog" />
  </v-app>
</template>

<script>
import SetResponsiblePersonDialog from "./components/core/SetResponsiblePersonDialog.vue";

export default {
  name: "DashboardIndex",
  components: {
    DashboardCoreAppBar: () => import("./components/iven/AppBar"),
    DashboardCoreDrawer: () => import("./components/iven/Drawer"),
    DashboardCoreSettings: () => import("./components/iven/Settings"),
    DashboardCoreView: () => import("./components/iven/View"),
    SetResponsiblePersonDialog
  },
  data: () => ({
    loginuser: JSON.parse(localStorage.getItem("user")) || 0,
    showResponsiblePersonDialog: false
  }),
  mounted() {
    let user = JSON.parse(localStorage.getItem("user")) || 0;
    if (user.user_status != "C") this.$router.push("/");
    // บังคับกรอกผู้รับผิดชอบระบบก่อนใช้งานต่อ — เตรียมข้อมูลไว้สำหรับขยาย ThaiID 2FA มากลุ่มนี้ในอนาคต
    if (user.must_set_responsible_person) this.showResponsiblePersonDialog = true;
  },
  methods: {
    home() {
      this.$router.push("iven");
    },
    logout() {
      localStorage.clear();
      this.$router.push("/");
    }
  }
};
</script>
<style>
.text_google {
  font-family: "Kanit", sans-serif;
}
.v-data-table thead th {
  font-size: 16px !important;
}

.table thead th {
  font-size: 16px !important;
}
</style>
